/**
 * Return target html element
 * 
 * @param {Element} selector 
 */
const getTargetElement = selector => {
  if (selector.classList.contains('dropdown-menu')) {
    return selector
  } else if (selector.querySelector('.dropdown-menu')) {
    return selector.querySelector('.dropdown-menu')
  } else {
    return selector
  }
}

/**
 * The same reason on using "target" variable as in listenForDropdownOpen()
 * Todo: needs refactor during searcher rewriting!
 * 
 * @param {Element} selector
 */
const calculateDropdownLocation = selector => {
  const target = getTargetElement(selector)  
  const screenHeight = window.innerHeight
  const dropdownHeight = target.clientHeight
  const additionalSpace = 20
  const dropdownTopOffset = target.getBoundingClientRect().top + additionalSpace
  const requiredSpace = dropdownHeight + dropdownTopOffset
  const pixelsToScroll = requiredSpace - screenHeight

  if (screenHeight < requiredSpace) {
    window.scrollBy(0, pixelsToScroll)
  }
}

/**
 * Return proper html target to observe
 * 
 * @param {Element} selector 
 * @param {Array} list 
 */
const getHandleTargetToObserve = (selector, list) => {
  for (const el of list) {
    const target = selector.querySelector(`.${el}`)
    if (target !== null) return target
  }
  
  return selector
}

/**
 * Listen for dropdown open
 * 
 * @param {Element} selector 
 */
const listenForDropdownOpen = selector => {
  /**
   * There's need to add class list which we'll observe because of big differences
   * between blocks '*=[custom-select-]', HTML structure inside and "open" class handling
   * on "dropdown-menu"
   * TODO: needs refactor during searcher rewriting!
   */
  const classList = [ 'custom-select-date__container', 'dropdown-menu.open' ]
  const target = getHandleTargetToObserve(selector, classList)

  const observerConfig = {
    childList: true,
    attributes: true,
  }

  const cb = mutationsList => {
    if (mutationsList.length) {
      /**
       * Little timeout is required because each target element has display:none which
       * causes that we don't have informations about elements height before click
       */
      setTimeout(() => {
        calculateDropdownLocation(mutationsList[0].target)
      }, 100)
    }
  }

  const observer = new MutationObserver(cb)
  observer.observe(target, observerConfig)
}

const screenPositionOnSelect = () => {
  const body = document.querySelector('body')
  const selectors = document.querySelectorAll('form > div[class*="custom-select-"]')

  // There's no need to run this code on every listing page
  if (!body.classList.contains('page--listing')) {
    selectors.forEach(listenForDropdownOpen)
  }
}

export default screenPositionOnSelect


// WEBPACK FOOTER //
// ./src/modules/customizations/screenPositionOnSelect.js